import Styles from '../AddReviewers/AddReviewers.module.scss'
import { SharedRecipientSelector } from 'components/ShareSheet/RecipientSelector/SharedRecipientSelector'
import { RecipientsSelectorProps } from 'components/ShareSheet/RecipientSelector/Types'
import { forwardRef } from 'react'
import { useSourceData } from '../SourceDataProvider/SourceDataProvider'

export interface Props
  extends Pick<
    RecipientsSelectorProps,
    'recipients' | 'id' | 'onChange' | 'className' | 'disabled' | 'onRecipientActionClick' | 'reviewerRolesDropdown'
  > {
  includeGroups?: boolean
  placeholder?: string
}

export const RecipientsSelector = forwardRef<HTMLDivElement, Props>(
  (
    { includeGroups = true, placeholder = 'Add people or external emails', onRecipientActionClick, ...props },
    fRef,
  ) => {
    const sourceData = useSourceData({ includeGroups })

    return (
      <SharedRecipientSelector
        {...props}
        ref={fRef}
        placeholder={placeholder}
        className={Styles.recipientsSelector}
        sourceData={sourceData}
        onRecipientActionClick={onRecipientActionClick}
      />
    )
  },
)
